// extracted by mini-css-extract-plugin
module.exports = {"container":"error_container__3KJzT","loaderText":"error_loaderText__3lVUN","loaderSubText":"error_loaderSubText__3Ztho"};